import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowUpward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.125 5.25 5.454 1.579a.72.72 0 0 1-.225-.527q0-.302.23-.541a.745.745 0 0 1 1.058.006l4.954 4.96a.72.72 0 0 1 .216.526q0 .15-.052.282a.7.7 0 0 1-.156.236l-4.958 4.958a.72.72 0 0 1-.521.23.73.73 0 0 1-.52-.22.77.77 0 0 1-.23-.545.7.7 0 0 1 .23-.527L9.124 6.75H.749a.73.73 0 0 1-.534-.214A.72.72 0 0 1 0 6.004q0-.316.215-.535A.72.72 0 0 1 .75 5.25z"
    />
  </svg>
);
export default SvgArrowUpward;
